import { render, staticRenderFns } from "./TenantLayout.vue?vue&type=template&id=23a44a9b&scoped=true"
import script from "./TenantLayout.vue?vue&type=script&lang=js"
export * from "./TenantLayout.vue?vue&type=script&lang=js"
import style0 from "./TenantLayout.vue?vue&type=style&index=0&id=23a44a9b&prod&lang=css"
import style1 from "./TenantLayout.vue?vue&type=style&index=1&id=23a44a9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a44a9b",
  null
  
)

export default component.exports